import Cart from 'cart-store';
import { formatMoney } from 'utils';

// Align the visible cards' purchase buttons with the bottom of the viewport.
document.addEventListener('click', event => {
  const link = event.target.closest('[data-subscribe-scroll]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const anchor = document.getElementById('subscribe-beers');
  const collection = anchor?.closest('.bd-subscribe-collection');
  if (!collection) return;
  const track = collection.querySelector('[data-items]');
  const bounds = track?.getBoundingClientRect();
  const buttons = Array.from(collection.querySelectorAll('.bd-subscribe-card .bigdrop-recommendation-card__cta'))
    .filter(button => {
      const rect = button.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.right > Math.max(0, bounds?.left ?? 0)
        && rect.left < Math.min(window.innerWidth, bounds?.right ?? window.innerWidth);
    });
  if (!buttons.length) return;
  event.preventDefault();
  const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
  const bottomInset = window.innerWidth <= 767 ? 24 : 60;
  const buttonBottom = Math.max(...buttons.map(button => button.getBoundingClientRect().bottom));
  window.scrollTo({
    top: Math.max(0, window.scrollY + buttonBottom - viewportHeight + bottomInset),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
});

if (!customElements.get('bigdrop-subscribe-card')) {
  customElements.define('bigdrop-subscribe-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const form = this.querySelector('form');
      if (!form) return;
      const choices = Array.from(form.querySelectorAll('[data-choice]'));
      const selectedChoice = () => choices.find(choice => choice.checked);
      const button = form.querySelector('[name="add"]');
      const status = form.querySelector('[data-status]');
      const quantity = form.elements.quantity;
      const quantityButtons = Array.from(form.querySelectorAll('[data-quantity-change]'));
      const updateButtonPrice = () => {
        const count = Math.max(1, Number(quantity.value) || 1);
        const total = formatMoney(Number(selectedChoice().dataset.priceCents) * count, window.theme.money_format);
        button.textContent = `Add to basket · ${total}`;
      };
      const updateQuantity = () => {
        quantityButtons.forEach(control => {
          control.disabled = button.disabled || (control.dataset.quantityChange === '-1' && Number(quantity.value) <= 1);
        });
        if (!button.disabled) updateButtonPrice();
      };
      quantityButtons.forEach(control => control.addEventListener('click', () => {
        quantity.value = Math.max(1, (Number(quantity.value) || 1) + Number(control.dataset.quantityChange));
        updateQuantity();
      }));
      quantity.addEventListener('input', updateQuantity);
      quantity.addEventListener('change', updateQuantity);
      const update = () => {
        const option = selectedChoice();
        form.elements.id.value = option.dataset.variant;
        form.elements.selling_plan.value = option.dataset.plan;
        form.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = form.querySelector('[data-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = option.dataset.discounted !== 'true';
        updateButtonPrice();
        status.textContent = '';
      };
      update();
      updateQuantity();
      choices.forEach(choice => {
        choice.disabled = false;
        choice.addEventListener('change', update);
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        update();
        button.disabled = true;
        choices.forEach(choice => { choice.disabled = true; });
        quantity.readOnly = true;
        updateQuantity();
        form.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding…';
        try {
          await Cart.add({ id: form.elements.id.value, selling_plan: form.elements.selling_plan.value, quantity: Number(quantity.value) });
          status.textContent = 'Subscription added to your cart.';
          const link = document.createElement('a');
          link.href = `${window.Shopify?.routes?.root ?? '/'}cart`;
          link.textContent = ' View cart';
          status.appendChild(link);
        } catch (error) {
          status.textContent = error.message || 'Unable to add your subscription. Please try again.';
        } finally {
          button.disabled = false;
          choices.forEach(choice => { choice.disabled = false; });
          quantity.readOnly = false;
          updateQuantity();
          updateButtonPrice();
          form.removeAttribute('aria-busy');
        }
      });
    }
  });
}
